module.exports = __webpack_public_path__ + "static/media/stimulus.c632eea6.jpg";